module.exports = __webpack_public_path__ + "img/front_buttons_quantity.56c208c5.png";